import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from 'app/redux/store';

import { OctadeskState } from '../types';

const initialState: OctadeskState = {
  showButton: true,
};

const octadeskSlice = createSlice({
  name: 'octadesk',
  initialState,
  reducers: {
    setShowButtonAction(state, action: PayloadAction<boolean>) {
      state.showButton = action.payload;
    },
  },
});

export const { setShowButtonAction } = octadeskSlice.actions;

export const getOctadesk = (state: RootState): OctadeskState => state.octadesk;

export default octadeskSlice.reducer;
